import React, { useEffect, useRef, useState } from "react";
import "./styles.scss";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { scheme } from "./validation";
import {
  FileInput,
  Flex,
  LoadingOverlay,
  Select,
  Text,
  TextInput,
} from "@mantine/core";
import Button from "../../components/elements/Button";
import DropzoneInput from "../../components/elements/DropzoneInput";

interface FormMasterLevelProps {
  type?: string;
  data?: any;
  loading?: boolean;
  onClose: () => void;
  handleSubmitData: (data: any) => void;
}

interface MasterLevelData {
  levelName?: string;
  levelImage?: string;
  xpMinimum?: string;
  xpMaksimum?: string;
  status?: string;
}

const FormMasterLevel: React.FC<FormMasterLevelProps> = ({
  onClose,
  loading,
  type,
  data,
  handleSubmitData,
}) => {
  const fileInputRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(null);

  const {
    control,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<MasterLevelData>({
    defaultValues: {
      levelName: data?.levelName || "",
      levelImage: data?.levelImage || null,
      xpMinimum: data?.xpMinimum || "0",
      xpMaksimum: data?.xpMaksimum || "0",
      status: data?.status || "",
    },
    resolver: yupResolver(scheme),
  });

  const handleSubmitForm: SubmitHandler<MasterLevelData> = (values) => {
    if (values.status === "Active") {
      values.status = "Y";
    } else {
      values.status = "N";
    }
    handleSubmitData(values);
  };

  const handleDrop = (files: File[], base64: string, field: any) => {
    const levelImage = { fileName: files[0].name, base64: base64 };
    field.onChange(JSON.stringify(levelImage));
  };

  return (
    <>
      <section className="master-category-content__form">
        <form onSubmit={handleSubmit(handleSubmitForm)}>
          {/* Text Input */}
          <TextInput
            label="Level Name"
            radius={10}
            withAsterisk
            placeholder="Input level name"
            error={errors.levelName?.message}
            {...register("levelName")}
          />
          {/* file input */}
          <Controller
            control={control}
            rules={{
              required: true,
            }}
            render={({ field }) => (
              <DropzoneInput
                label="Level Image"
                withAsterik
                onHandleDrop={(value, base64) =>
                  handleDrop(value, base64, field)
                }
                error={errors?.levelImage?.message || ""}
                defaultValue={data?.levelImage || null}
              />
            )}
            name="levelImage"
          />
          <TextInput
            label="XP Minumum"
            radius={10}
            withAsterisk
            placeholder="Input XP Minumum"
            error={errors.xpMinimum?.message}
            {...register("xpMinimum")}
          />
          <TextInput
            label="XP Maksimum"
            radius={10}
            withAsterisk
            placeholder="Input XP Maksimum"
            error={errors.xpMaksimum?.message}
            {...register("xpMaksimum")}
          />
          <Controller
            control={control}
            rules={{
              required: true,
            }}
            render={({ field }) => (
              <div>
                <Select
                  className={
                    errors.status?.message &&
                    "master-rater__form__selectinput--error"
                  }
                  label="Status"
                  withAsterisk
                  placeholder="Select Status"
                  onChange={field.onChange}
                  value={field.value}
                  data={["Active", "InActive"]}
                />
                {errors?.status?.message && (
                  <Text size="xs" c="red" fw={400}>
                    {errors.status.message}
                  </Text>
                )}
              </div>
            )}
            name="status"
          />

          <Flex justify="flex-end" align="center" gap={16} mt={32}>
            <Button variant="error-beelajar" onClick={onClose}>
              Cancel
            </Button>
            <Button disabled={loading} type="submit">
              {type === "add" ? "Submit" : "Update"}
            </Button>
          </Flex>
        </form>
      </section>
      <LoadingOverlay visible={loading} />
    </>
  );
};

export default FormMasterLevel;
